export const SYSTEM_DATE_PATTERN = 'MM/dd/y';

export const INPUT_DATE_PATTERN = 'yyyy-MM-dd';
export const INPUT_MONTH_PATTERN = 'yyyy-MM';
